let grades = [
  {
    label: '本科一年级'
  },
  {
    label: '本科二年级'
  },
  {
    label: '本科三年级'
  },
  {
    label: '本科四年级'
  },
  {
    label: '本科五年级'
  },
  {
    label: '本科毕业'
  },
  {
    label: '硕士一年级'
  },
  {
    label: '硕士二年级'
  },
  {
    label: '硕士三年级'
  },
  {
    label: '硕士毕业'
  },
  {
    label: '博士在读'
  },
  {
    label: '博士毕业'
  }
];
grades = grades.map(item => {
  return {
    label: item.label,
    value: item.label
  };
});
export default grades;
